module.exports = __webpack_public_path__ + "img/local_select.d25453d4.png";